import type {
  PackagingFieldCrossCheckIssueCode,
  PackagingSupplierComplianceProgress,
  PackagingSupplierOnboardingStatus,
  PackagingSupplierRedFlag,
} from '@/shared/hooks/api/packagingSuppliers'
import type { PackagingSupplierFunnelStage } from './packagingSupplierStats'

export const PACKAGING_SUPPLIER_FUNNEL_STAGE_VALUES = [
  'NOT_OPENED',
  'OPENED',
  'ACKNOWLEDGED',
  'WITH_PACKAGING_ITEMS',
  'ALL_ITEMS_COMPLETE',
] as const satisfies readonly PackagingSupplierFunnelStage[]

export const PACKAGING_SUPPLIER_COMPLIANCE_PROGRESS_VALUES = [
  'NO_ITEMS',
  'DRAFT_ITEMS',
  'ALL_ITEMS_COMPLETE',
] as const satisfies readonly PackagingSupplierComplianceProgress[]

export const PACKAGING_SUPPLIER_RED_FLAG_VALUES = [
  'HEAVY_METALS',
  'SUBSTANCES_OF_CONCERN',
  'INCOMPLETE_INFORMATION',
] as const satisfies readonly PackagingSupplierRedFlag[]

export const PACKAGING_FIELD_CROSS_CHECK_ISSUE_CODE_VALUES = [
  'NAME_DESCRIPTION_MISMATCH',
  'DESCRIPTION_MATERIAL_MISSING_FROM_COMPONENTS',
  'COMPONENT_NAME_MATERIAL_MISMATCH',
  'MISSING_DIELINE_DIAGRAM',
  'MISSING_HEAVY_METALS_TEST_REPORT',
  'MISSING_HEAVY_METALS_CONFORMITY_STATEMENT',
  'MISSING_SUBSTANCES_OF_CONCERN_TEST_REPORT',
  'MISSING_SUBSTANCES_OF_CONCERN_CONFORMITY_STATEMENT',
  'COMPLETED_WITHOUT_COMPONENTS',
  'UNREADABLE_OR_PROTECTED_DOCUMENT',
  'UNSUPPORTED_DOCUMENT_FILE_TYPE',
  'COMPONENT_MATERIAL_RECYCLING_STREAM_MISMATCH',
] as const satisfies readonly PackagingFieldCrossCheckIssueCode[]

export const PACKAGING_SUPPLIER_OVERVIEW_COLUMN_IDS = [
  'name',
  'funnelStatus',
  'redFlags',
] as const

export const REMOVED_PACKAGING_SUPPLIER_OVERVIEW_COLUMN_IDS = [
  'firstOpened',
  'acknowledged',
] as const

export function funnelStageLabelKey(
  stage: PackagingSupplierFunnelStage
):
  | 'list.onboardingStatus.INVITE_SENT'
  | 'stats.suppliersOpened'
  | 'stats.suppliersAcknowledged'
  | 'stats.suppliersWithPackagingItems'
  | 'stats.suppliersWithAllItemsComplete' {
  switch (stage) {
    case 'NOT_OPENED':
      return 'list.onboardingStatus.INVITE_SENT'
    case 'OPENED':
      return 'stats.suppliersOpened'
    case 'ACKNOWLEDGED':
      return 'stats.suppliersAcknowledged'
    case 'WITH_PACKAGING_ITEMS':
      return 'stats.suppliersWithPackagingItems'
    case 'ALL_ITEMS_COMPLETE':
      return 'stats.suppliersWithAllItemsComplete'
  }
}

export function onboardingStatusLabelKey(
  status: PackagingSupplierOnboardingStatus
): `list.onboardingStatus.${PackagingSupplierOnboardingStatus}` {
  return `list.onboardingStatus.${status}`
}

export function complianceProgressLabelKey(
  progress: PackagingSupplierComplianceProgress
): `list.complianceProgress.${PackagingSupplierComplianceProgress}` {
  return `list.complianceProgress.${progress}`
}

export function redFlagLabelKey(
  flag: PackagingSupplierRedFlag
): `list.redFlags.issues.${PackagingSupplierRedFlag}.label` {
  return `list.redFlags.issues.${flag}.label`
}

export function redFlagDescriptionKey(
  flag: PackagingSupplierRedFlag
): `list.redFlags.issues.${PackagingSupplierRedFlag}.description` {
  return `list.redFlags.issues.${flag}.description`
}

export function auditIssueLabelKey(
  code: PackagingFieldCrossCheckIssueCode
): `fieldCrossCheck.checks.${PackagingFieldCrossCheckIssueCode}` {
  return `fieldCrossCheck.checks.${code}`
}
